import { Outlet } from 'react-router-dom'
import './Section.css'

function Lists() {
  return (
    <div className="dashboard-section">
      <Outlet />
    </div>
  )
}

export default Lists
